<app-header title="Manage Campaigns"></app-header>
<ng-container [formGroup]="option">
    <div>
        <div class="card__title mb-4">Option Image</div>
        <div class="row">
            <div class="col-4">
                <div class="body-1 mb-1 text-center">Cover Image</div>
                <div class="image-block mb-1">
                    <div
                        *ngIf="option.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                        class="image-block__file-container d-flex align-items-center justify-content-center"
                    >
                        <app-input-file class="position-absolute" [classes]="['btn--paybee-custom']" accept="image/png,image/jpeg" label="Upload" formControlName="imageFile"></app-input-file>
                    </div>
                    <div
                        *ngIf="option.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                        class="image-block__file-container d-flex align-items-start justify-content-end"
                    >
                        <app-icon-delete (click)="resetImageByType('image')" class="position-absolute cursor--pointer m-2"></app-icon-delete>
                    </div>
                    <img class="image-block__image" [src]="option.controls.imageDataUrl.value">
                </div>
            </div>

            <div class="col-4"></div>
            
            <div class="col-4 d-flex flex-column align-items-center pr-0">
                <div class="d-flex flex-row align-items-center">
                    <div class="body-1 mr-1">Thumbnail</div>
                    <i data-toggle="tooltip" data-placement="left" title="This will be seen by donors viewing this campaign on mobile phones" class="blue-text far fa-question-circle"></i>
                </div>
                <div class="image-block mb-1  w-50">
                    @if(option.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
                        <div class="image-block__file-container d-flex align-items-center justify-content-center">
                            <app-input-file formControlName="thumbnailFile" [classes]="['btn--paybee-custom']" [minSize] ='200' class="position-absolute" label="Upload" accept="image/png,image/jpeg"></app-input-file>
                        </div>
                    }
                    @if(option.controls.thumbnailDataUrl.value !== '/images/blank_1x1.png'){
                        <div class="image-block__file-container d-flex align-items-start justify-content-end">
                            <app-icon-delete (click)="resetImageByType('thumbnail')" class="position-absolute cursor--pointer m-2"></app-icon-delete>
                        </div>
                    }
                    <img class="image-block__image" [src]="option.controls.thumbnailDataUrl.value">
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-4 text-center">
                @if(option.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(0)" class="blue-text body-2">Choose from previously used images</a>
                }
            </div>
            <div class="col-4"></div>
            <div class="col-4 pr-0 text-center">
                @if(option.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
                    <span  class="d-block blue-text body-2">OR</span>
                    <a (click)="openChooseImageModal(1)" class="d-block blue-text body-2">Choose from previously used images</a>
                        <div [ngStyle]="{'display': option.controls.imageDataUrl.value == '/images/blank_2x1.png' ? 'none' : 'flex'}"  class="flex-row align-items-center justify-content-center">
                            <a (click)="generateThumbnail()" class="blue-text body-2 mr-1">Generate Thumbnail from main image</a>
                            <!-- <i data-toggle="tooltip" data-placement="left" title="Generates a thumbnail from the option image" class="blue-text far fa-question-circle"></i> -->
                        </div>
                }
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="name"  label='Option Name'></app-mdbp-input>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.name.hasError('required') && option.controls.name.touched">Please provide Name</mdb-error>
                </mdb-form-control>
            </div>
            <div class="col-4">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="amount" [isCurrencyMask]="true" label='Amount'>
                        <input  #inputNameC currencyMask formControlName="amount" [options]="{'precision': 2}" class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.amount.hasError('required') && option.controls.amount.touched">Allowed amount $1 to $400,000</mdb-error>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.amount.hasError('min') && option.controls.amount.touched">Allowed amount $1 to $400,000</mdb-error>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.amount.hasError('max') && option.controls.amount.touched">Allowed amount $1 to $400,000</mdb-error>
                </mdb-form-control>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="valueProvided" [isCurrencyMask]="true" label='Value of goods or services provided, If any!'>
                        <input  #inputNameC currencyMask formControlName="valueProvided" [options]="{'precision': 2}" class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    @if(option.controls.valueProvided.hasError('max') && option.controls.valueProvided.touched){<mdb-error class="form-fill-error">Allowed value to {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }}</mdb-error>}
                </mdb-form-control>
            </div>
            <div class="col-4">
              <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                  placement="bottom"
                  type="learn-more"
                  title="Learn more"
                >
                </app-text-popover>
              </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <app-mdb-switch label="Any additional info required" formControlName="additionalInfoRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" *ngIf="option.value.additionalInfoRequired">
                    <mdb-form-control class="form-fill" data-panel="general">
                        <app-mdbp-input mdbInput formControlName="additionalInfoDesc" data-panel="general" label='Additional info description'></app-mdbp-input>
                        <mdb-error class="form-fill-error"  *ngIf="option.controls.additionalInfoDesc.hasError('required') && option.controls.additionalInfoDesc.touched ">Please provide Description</mdb-error>
                    </mdb-form-control>
                    <div class="position-relative mb-4">
                        <label class="form-check-label form-check-label--paybee mb-1">Instructions for additional info (optional)</label>
                        <mdb-form-control class="mb-4">
                            <app-quill-custom mdbInput formControlName="additionalInfoDetail" limit="2048"></app-quill-custom>
                        </mdb-form-control>     
                    </div>
                    <span class="form-fill-error"  *ngIf="option.controls.additionalInfoDetail.invalid" style="margin-top: -20px;">Invalid link</span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <app-mdb-switch label="Any additional info, to be selected by user" formControlName="additionalInfoSelectRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" [ngClass]="additionalInfoSelectRequiredClassess">
                    <mdb-form-control class="form-fill" data-panel="general">
                        <app-mdbp-input mdbInput formControlName="additionalInfoSelectDesc" data-panel="general" label='Additional info select description'></app-mdbp-input>
                        <mdb-error class="form-fill-error"  *ngIf="option.controls.additionalInfoSelectDesc.hasError('required') && option.controls.additionalInfoSelectDesc.touched">Please provide Description</mdb-error>
                    </mdb-form-control>
                    <p class="mb-0 grey-text small"> Type a option and press enter to add. Click <strong>X</strong> to remove it. </p>
                    <app-chips
                        placeholder="Press Enter to add each Tag"
                        formControlName="additionalInfoSelect"
                        [touched]="additionalInfoSelect.touched"
                        [required]="option.value.additionalInfoSelectRequired"
                        idChips="additionalInfoSelect"
                    ></app-chips>
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12">
                <div class="position-relative mb-4">
                    <div class="d-flex flex-row align-items-center mb-1">
                        <label class="form-check-label form-check-label--paybee mr-2">Description</label>
                        <app-text-popover
                            placement="bottom"
                            type="content"
                            text="Add a detailed description to describe this option. This is displayed when donors tap on the Details button when viewing the list of options in this campaign."
                            title=""
                        >
                        </app-text-popover>
                    </div>
                    <mdb-form-control>
                        <app-quill-custom mdbInput formControlName="desc" limit="512"></app-quill-custom>
                    </mdb-form-control>  
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="position-relative mb-4">
                    <div class="d-flex align-items-center mb-2">
                        <div class="d-flex flex-row align-items-center mb-1">
                            <label class="form-check-label form-check-label--paybee mr-2">Summary</label>
                            <app-text-popover
                                placement="bottom"
                                type="content"
                                text="Add a short summary to describe this option. This is displayed when donors are viewing the list of options in this campaign."
                                title=""
                            >
                            </app-text-popover>
                          </div>
                          @if(option.get('desc').value !== ''){
                            <div class="d-flex justify-content-end w-100">
                                <a (click)="generateSummary(0)" class="blue-text body-2">Generate Summary From Description</a>
                            </div>
                          }
                    </div>
                    <mdb-form-control>
                        <app-quill-custom mdbInput formControlName="summary" [options]="quillOptions" limit="256"></app-quill-custom>
                    </mdb-form-control>  
                </div>
            </div>
        </div>
    </div>
</ng-container>
